import { Model } from '@/models/Model';
export class Address extends Model {
    constructor() {
        super(...arguments);
        this.$name = 'Address';
        this.$endpoint = '/addresses';
    }
}
